import React from 'react';

import {useTranslation} from '@aboutyou/i18n';
import {Heading16, Heading20} from '@aboutyou/ui-components';
import styled from 'styled-components';
import {ArrowButton} from '../shared/ArrowButton';
import {HelpCenterNavigationContainer} from '../shared/HelpCenterNavigationContainer';
import {GetSelfServiceFlowSectionResponse} from '../types';

interface HighlightedArticlesViewProps {
  highlightedArticles: GetSelfServiceFlowSectionResponse['highlightedArticles'];
  smallTitle?: boolean;
}

export const HighlightedArticlesView = ({
  highlightedArticles,
  smallTitle = false,
}: HighlightedArticlesViewProps) => {
  const {t} = useTranslation();

  if (highlightedArticles.length === 0) {
    return null;
  }
  const TitleComponent = smallTitle ? Heading16 : Heading20;

  return (
    <HelpCenterNavigationContainer
      light
      data-testid="HighlightedArticlesContainer"
    >
      <Margin>
        <TitleComponent>{t('Other FAQs')}</TitleComponent>
      </Margin>
      <LinksContainer>
        {highlightedArticles.map(link => (
          <ArrowButton
            key={link.linkTarget.url}
            href={link.linkTarget.url}
            aria-label={undefined}
          >
            {link.label}
          </ArrowButton>
        ))}
      </LinksContainer>
    </HelpCenterNavigationContainer>
  );
};

const LinksContainer = styled.div`
  max-width: 430px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const Margin = styled.div`
  margin-bottom: 40px;
`;
